import React, { useState, useEffect } from "react";
import { Control, actions } from "react-redux-form";
import { Button, Col, Row } from "reactstrap";
import { compose, withHandlers, withPropsOnChange } from "recompose";
import { useHistory } from "react-router-dom";
import {
  FormGroup,
  DatePicker,
  SubmitButton,
  withLocalForm,
  XeroAutoComplete,
} from "components/common";
import Select from "react-select";
import { Trans, withTranslation } from "react-i18next";
import { formatXeroDate } from "services/util";
import { invoiceBulkPost } from "components/common/ZatcaSendInvoice";
import { useBaseModal } from "services";
import { SelectedItemsDisplay } from "components/common/ZatcaSelected";
import withDocumentRenderer from "components/DocumentRenderer/withDocumentRenderer";
import BulkInvoiceDocument from "components/documents/BulkInvoiceDocument";
import { useOrganisationContext } from "hooks";

const DownloadButton = withDocumentRenderer({
  onDownload: () => (getDocument, item) =>
    getDocument(
      {
        item,
      },
      `Invoices_set.pdf`
    ),
})(({ DownloadDocument, DocumentRenderer, item, disabled, selectedOrganisation, validation, setDownloadHandler, EmailDocument }) => (
  <div>
    <DownloadDocument disabled={disabled} selectedOrganisation={selectedOrganisation} validation={validation} setDownloadHandler={setDownloadHandler} item={item} />
    {item && (
      <EmailDocument className="ml-3" disabled={disabled} type="BULK_INVOICES" selectedOrganisation={selectedOrganisation} validation={validation} setDownloadHandler={setDownloadHandler} item={item} />
    )}
    <DocumentRenderer component={BulkInvoiceDocument} selectedOrganisation={selectedOrganisation} />
  </div>
));


export const Search = ({
  LocalForm,
  handleSubmit,
  searchWithinOptions,
  handleClear,
  setSimpleType,
  useSimpleType,
  exportTypeShow,
  selectedItems,
  creditNote = false,
  selectedOrganisation,
  t,
  dispatch,
  isInvoice,
  isBill,
  status,
  setSelectedDocType,
  ...props
}) => {
  const history = useHistory();

  const isZatcaSubscribed = selectedOrganisation.onboarding_date

  const type = creditNote ? "CreditNote" : (isInvoice ? "Invoice" : "Bill")

  const [invoiceSDKZatca, setSDKZatcaData] = useState(null);
  const [callbackFunc, setCallbackFunc] = useState();

  const [setZatcaModal, ZatcaToggle, ZatcaModal] = useBaseModal();

  const docType = creditNote ? "creditnote" : "invoice"
  const clearanceStatus = useSimpleType ? "1" : "0";
  const invoiceType = useSimpleType ? "simplified" : "standard";
  const formattedType = invoiceType.charAt(0).toUpperCase() + invoiceType.slice(1) + ` Tax ${type}`;

  const setDownloadHandler = (func) => {
    setCallbackFunc(() => func);
  }

  useEffect(() => {
    if (!isInvoice)
      return null
    const items = selectedItems;
    const mapItemToMappedData = (item) => {
      if (creditNote) {
        return invoiceBulkPost(item, docType, item?.Allocations?.[0]?.Invoice?.InvoiceNumber || item.AllocationInvoice);
      } else {
        return invoiceBulkPost(item, docType);
      }
    };

    const mappedData = items?.map(mapItemToMappedData);

    setSDKZatcaData(mappedData);

  }, [selectedItems, docType, clearanceStatus, invoiceType]);

  const handleBatchPayment = async () => {
    if (selectedItems?.length === 0) {
      return;
    };

    history.push({ pathname: "/batch-payments/new", state: selectedItems });
  };

  const [contactKey, setContactKey] = useState(0);
  const clearContact = () => {
    dispatch(actions.reset('local.contactIDs'));

    setContactKey(prevKey => parseInt(prevKey) + 1);
  };

  return (
    <>
      <LocalForm onSubmit={handleSubmit}>
        <div className="d-inline-block account-receivable-search">
          <Row className="small">
            <Col xs="3" className="my-1">
              <FormGroup
                label="Enter Number or Reference"
                className="text-nowrap"
              >
                <Control.text className="form-control" model=".description" />
              </FormGroup>
            </Col>
            <Col xs="3" className="my-1">
              <FormGroup
                model=".contactIDs"
                label={t("Filter by Contact")}
              >

                <XeroAutoComplete
                  key={contactKey}
                  model=".contactIDs"
                  value={props.state?.contactIDs || ''}
                  multi={false}
                  // autoload={autoload}
                  onChange={(e) => dispatch(actions.change('local.contactIDs', e && e.ContactID))}
                  valueKey={'ContactID'}
                  labelKey={"Name"}
                  url="contacts"
                  placeholder={t('Select...')}
                  searchPromptText={t('Type to search')}
                />

              </FormGroup>
            </Col>
            <Col xs="6" className="my-1">
              <Row>
                <Col xs="4">
                  <FormGroup
                    label="Search Within"
                    addControlClass={false}
                    className="text-nowrap"
                  >
                    <Control.text
                      component={Select}
                      style={{ minWidth: '8rem', backgroundColor: '#F4F7FE' }}
                      model=".searchWithin"
                      simpleValue
                      clearable={false}
                      options={searchWithinOptions}
                    />
                  </FormGroup>
                </Col>
                <Col xs="4">
                  <FormGroup label="Start Date" className="text-nowrap">
                    <DatePicker
                      className="form-control form-control-sm"
                      model=".startDate"
                    />
                  </FormGroup>
                </Col>
                <Col xs="4">
                  <FormGroup label="End Date" className="text-nowrap">
                    <DatePicker
                      className="form-control form-control-sm"
                      model=".endDate"
                    />
                  </FormGroup>
                </Col>
              </Row>
            </Col>
            <Col xs="3" className="my-1">
              <FormGroup label="Amount" className="text-nowrap">
                <Control.text
                  className="form-control"
                  model=".amount"
                  placeholder={t("Total, Paid, Due Amount")}
                />
              </FormGroup>
            </Col>
          {isZatcaSubscribed && isInvoice && (status === "PAID" || status === "AUTHORISED" || status === "PAID,AUTHORISED") && <Col xs="3" className="my-1">
            <FormGroup label="Zatca Status" className="text-nowrap" addControlClass={false}>
              <Control.text
                component={Select}
                style={{ minWidth: '8rem', backgroundColor: '#F4F7FE' }}
                model=".zatca_status"
                simpleValue
                clearable={false}
                options={[
                  {label: t('Reported'), value:'reported'},
                  {label: t('Failed'), value:'failed'},
                  {label: t('Non Reported'), value:'unreported'},
                ]}
              />
            </FormGroup>
          </Col>}
           {!isBill && <Col xs="3" className="my-1">
              <FormGroup label="Document Type" className="text-nowrap" addControlClass={false}>
                <Control.text
                  component={Select}
                  style={{ minWidth: '8rem', backgroundColor: '#F4F7FE' }}
                  model=".docType"
                  simpleValue
                  clearable={true}
                  searchable={false}
                  onChange={(v) => setSelectedDocType(v || null)}
                  options={[
                    { label: t('Simplified'), value: 'simplified' },
                    { label: t('Standard'), value: 'standard' },
                    { label: t('Undefined'), value: 'undefined' },
                  ]}
                />
              </FormGroup>
            </Col>}
            <Col xs="3" className="my-1">
              <FormGroup addControlClass={false} label="&nbsp;">
                <FormGroup label="Unsent Only" check>
                  <Control.checkbox model=".unsentOnly" />
                </FormGroup>
                <FormGroup label="Include Deleted & Voided" check>
                  <Control.checkbox model=".includeDeletedAndVoided" />
                </FormGroup>
              </FormGroup>
            </Col>
            <Col xs="auto" className="my-1 d-flex align-items-end">
              <SubmitButton size="sm" className="btn ml-0">Search</SubmitButton>
              <Button size="sm" className="btn btn-clear btn-danger" onClick={() => { handleClear(); clearContact(); }} style={{ color: '#fff' }}>
                <Trans>Clear</Trans>
              </Button>
              {
                !!selectedItems.length &&
                <>
                  {isInvoice && isZatcaSubscribed && (status === "PAID" || status === "AUTHORISED" || status === "PAID,AUTHORISED") &&
                    <Button size="sm" disabled={selectedItems?.length === 0} className="btn btn-clear" onClick={() => setZatcaModal(true)} style={{ color: '#fff' }}>
                      <Trans>Send To Zatca</Trans>
                    </Button>
                  }
                  <div className="ml-2">
                    <DownloadButton selectedOrganisation={selectedOrganisation} disabled={selectedItems?.length === 0} validation={() => true} setDownloadHandler={setDownloadHandler} item={selectedItems} />
                  </div>
                  <div className="ml-2">
                    {props.status === "AUTHORISED" && (
                      <Button color="primary" type="button" size="sm" onClick={handleBatchPayment}>
                        <Trans> Make payment</Trans>
                      </Button>
                    )}
                  </div>
                </>
              }
              {isInvoice && <ZatcaModal title={(`Send ${docType.charAt(0).toUpperCase() + docType.slice(1)}s To Zatca`)} size="lg">
                <SelectedItemsDisplay
                  invoiceSDKZatca={invoiceSDKZatca?.filter((invoice) => !(invoice.Reporting?.reported || invoice.Reporting?.cleared))}
                  setSDKZatcaData={setSDKZatcaData}
                  docType={docType}
                  formattedType={formattedType}
                  setZatcaModal={setZatcaModal}
                  t={t}
                />
              </ZatcaModal>
              }
            </Col>
          </Row>
        </div>
      </LocalForm>
    </>
  )
};

export const enhance = compose(
  withLocalForm({
    initialState: {
      description: "",
      searchWithin: "transactiondate",
      status: "",
      startDate: null,
      endDate: null,
      unsentOnly: false,
      includeDeletedAndVoided: false,
      contactIDs: ''
    },
  }),
  withTranslation(),
  withPropsOnChange(["language"], ({ t, invoice }) => {
    return {
      searchWithinOptions: [
        {
          label: t("Date"),
          value: "transactiondate",
        },
        ...(invoice
          ? [
            {
              label: t("Due Date"),
              value: "duedate",
            },
          ]
          : []),
        ...(invoice
          ? [
            {
              label: t("Any date"),
              value: "any",
            },
          ]
          : []),
      ],
    };
  }),
  withHandlers({
    handleSubmit: ({selectedOrganisation, ...props}) => (search) => {

      const items = [];
      const wpItems = {};
      if (search.description) {
        const d = search.description.replace(/"/g, "").toLowerCase();
        // const args = [
        //   props.invoice ? "InvoiceNumber" : "CreditNoteNumber",
        //   "Reference",
        //   "Contact.Name",
        //   'Url',
        // ]
        //   .map((v) => `(${v} != null AND ${v}.ToLower().Contains("${d}"))`)
        //   .join(" OR ");
        // if (isNumber(d.replace(/,/g, ''))){
        //   let term = `(Total=${parseFloat(d.replace(/,/g, ''))})`
        //   items.push(term);
        // }
        wpItems.search = d;
      }

      if (search.startDate || search.endDate) {
        switch (search.searchWithin) {
          case "any":
            if (search.startDate) {
              items.push(
                `(Date>=${formatXeroDate(
                  search.startDate
                )} OR DueDate>=${formatXeroDate(search.startDate)})`
              );
              wpItems.AnyDate__gte = search.startDate;
            }
            if (search.endDate) {
              items.push(
                `(Date<=${formatXeroDate(
                  search.endDate
                )} OR DueDate<=${formatXeroDate(search.endDate)})`
              );
              wpItems.AnyDate__lte = search.endDate;
            }
            break;
          case "transactiondate":
            if (search.startDate) {
              items.push(`Date>=${formatXeroDate(search.startDate)}`);
              wpItems.Date__gte = search.startDate;
            }
            if (search.endDate) {
              items.push(`Date<=${formatXeroDate(search.endDate)}`);
              wpItems.Date__lte = search.endDate;
            }
            break;
          case "duedate":
            if (search.startDate) {
              items.push(`DueDate>=${formatXeroDate(search.startDate)}`);
              wpItems.DueDate__gte = search.startDate;
            }
            if (search.endDate) {
              items.push(`DueDate<=${formatXeroDate(search.endDate)}`);
              wpItems.DueDate__lte = search.endDate;
            }
            break;
          default:
            break;
        }
      }

      if (search.amount) {
        items.push(`(Total=${parseFloat(search.amount.replace(/,/g, ''))} OR AmountPaid=${parseFloat(search.amount.replace(/,/g, ''))} OR AmountDue=${parseFloat(search.amount.replace(/,/g, ''))})`);
      }

      if (search.unsentOnly) {
        items.push("SentToContact!=true");
        wpItems.SentToContact = false;
      }
      if (props.invoice) {
        items.push(`Type="ACCREC"`);
        wpItems.Type = "ACCREC";
      } else if (props.isBill) {
        items.push(`Type="ACCPAY"`);
        wpItems.Type = "ACCRACCPAYEC";
      } else {
        items.push(`Type="${props.payable ? "ACCPAYCREDIT" : "ACCRECCREDIT"}"`);
        wpItems.Type = props.payable ? "ACCPAYCREDIT" : "ACCRECCREDIT";
      }

      if (search.zatca_status){
        if (search.zatca_status === 'reported'){
          items.push(`(Reference != null AND Reference.ToLower().Contains("zatca-reported") AND Date >= DateTime(${selectedOrganisation.onboarding_date}))`)
        }else if (search.zatca_status === 'failed'){
          items.push(`(Reference != null AND Reference.ToLower().Contains("zatca-rejected") AND Date >= DateTime(${selectedOrganisation.onboarding_date}))`)
        }else if (search.zatca_status === 'unreported'){
          items.push(`(Reference != null AND !Reference.ToLower().Contains("zatca-reported") AND Date >= DateTime(${selectedOrganisation.onboarding_date}))`) //weird but it works
        }
        if (selectedOrganisation.pos_contacts_ids) {
          const contactIds = selectedOrganisation.pos_contacts_ids?.split(',') || []
          const filterStrings = contactIds.map(contactId => `Contact.ContactID!=GUID("${contactId}")`);
          items.push(`(` + filterStrings.join(" AND ") + ')')
        }
      }

      let statuses = (props.status || "").split(",");

      if (search.includeDeletedAndVoided) {
        statuses = [...statuses, "VOIDED", "DELETED"];
      }
      wpItems.Statuses = statuses
      // statuses = statuses.map((i) => `Status="${i}"`).join(" OR ");
      // items.push(`(${statuses})`);

      props.onFiltersChanged({
        raw: items.length ? items.join(" AND ") : undefined,
        // ...wpItems,
        extra_params: {
          searchTerm: wpItems.search,
          Statuses: wpItems.Statuses,
          ContactIDs: search.contactIDs ? [search.contactIDs] : [],
          // summaryOnly: !search.amount && !search.unsentOnly
        }
      });
    },
    handleClear:
      ({ dispatch, onFiltersChanged }) =>
        () => {
          dispatch(actions.reset("local"));
          onFiltersChanged(null);
        },
  })
);

export default enhance(Search);
